<template>
    <section>
        <div class="flex flex-col grid-cols-10 gap-y-6 items-center md:grid">
           <div class="col-span-3">
            <nuxt-img 
                :src="leftImageSrc" 
                :alt="leftImageAlt" 
                width="858"
                height="1822"
                format="webp"
                loading="lazy"
                 sizes="xs:380px sm:480px md:241px lg:302px xl:355px 2xl:416px"
                class="hidden md:block"
            />

            <nuxt-img 
                :src="topMobileImageSrc" 
                :alt="topMobileImageAlt" 
                width="1920"
                height="1130"
                format="webp"
                loading="lazy"
                sizes="xs:380px sm:480px md:760px lg:1024px xl:1920px 2xl:1920px"
                class="md:hidden"
            />
           </div>

           <div class="col-span-4">
            <div class="px-10 mx-auto max-w-md">
                <h3 class="text-2xl text-center text-black xl:leading-tight font-ww-bold xl:text-42 md:text-3xl" v-html="mainTitle"></h3>
                
                <div class="mt-4 text-base text-center md:mt-8 xl:text-xl md:text-lg" v-html="testimonialText"></div>
            </div>
           </div>

          <div class="col-span-3">
              <nuxt-img 
                :src="rightImageSrc" 
                :alt="rightImageAlt" 
                width="858"
                height="1822"
                format="webp"
                loading="lazy"
              sizes="xs:380px sm:480px md:241px lg:302px xl:355px 2xl:416px"
                class="hidden md:block"
            />

            
            <nuxt-img 
                :src="bottomMobileImageSrc" 
                :alt="bottomMobileImageAlt" 
                width="1920"
                height="1130"
                format="webp"
                loading="lazy"
                sizes="xs:380px sm:480px md:760px lg:1024px xl:1920px 2xl:1920px"
                class="md:hidden"
            />


          </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const props = defineProps({
  leftImageSrc: {
    type: String,
    default: '/assets/images/left-testimonials.png'
  },
  leftImageAlt: {
    type: String,
    default: 'Testimonials Background Left'
  },
  rightImageSrc: {
    type: String,
    default: '/assets/images/right-testimonials.png'
  },
  rightImageAlt: {
    type: String,
    default: 'Testimonials Background Right'
  },
  topMobileImageSrc: {
    type: String,
    default: 'assets/images/top-testimonial.png'
  },
  topMobileImageAlt: {
    type: String,
    default: 'Top Testimonial Background Mobile'
  },
  bottomMobileImageSrc: {
    type: String,
    default: 'assets/images/bottom-testimonials.png'
  },
  bottomMobileImageAlt: {
    type: String,
    default: 'Bottom Testimonials Background Mobile'
  },
  mainTitle: {
    type: String,
    default: 'Why Customers Love Mindflow'
  },
  testimonialText: {
    type: String,
    default: '<span class="italic">"With Mindflow, I don\'t just get energy—I get focus. No jitters, no crash. Just hours of locked-in productivity."</span><br><br>— [Name], Verified Customer'
  }
})

defineBuilderComponent({
  friendlyName: 'Info Left Right Images',
  inputs: [
    {
      name: 'leftImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/left-testimonials.png'
    },
    {
      name: 'leftImageAlt',
      type: 'text',
      defaultValue: 'Testimonials Background Left'
    },
    {
      name: 'rightImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/right-testimonials.png'
    },
    {
      name: 'rightImageAlt',
      type: 'text',
      defaultValue: 'Testimonials Background Right'
    },
    {
      name: 'topMobileImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: 'assets/images/top-testimonial.png'
    },
    {
      name: 'topMobileImageAlt',
      type: 'text',
      defaultValue: 'Top Testimonial Background Mobile'
    },
    {
      name: 'bottomMobileImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: 'assets/images/bottom-testimonials.png'
    },
    {
      name: 'bottomMobileImageAlt',
      type: 'text',
      defaultValue: 'Bottom Testimonials Background Mobile'
    },
    {
      name: 'mainTitle',
      type: 'richText',
      defaultValue: 'Why Customers Love Mindflow'
    },
    {
      name: 'testimonialText',
      type: 'richText',
      defaultValue: '<span class="italic">"With Mindflow, I don\'t just get energy—I get focus. No jitters, no crash. Just hours of locked-in productivity."</span><br><br>— [Name], Verified Customer'
    }
  ]
})
</script>
